// Locale-aware date formatting shared by Events, Event Details, and News &
// Reviews. Firestore stores dates as plain strings/Timestamps — only the
// *display* format changes with the active language, never the stored value.
const LOCALE_MAP = {
  de: "de-DE",
  en: "en-GB",
};

const resolveLocale = (language) => LOCALE_MAP[language] || LOCALE_MAP.de;

// Formats an event's plain `date` string (e.g. "2026-08-22").
export const formatEventDate = (dateStr, language) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? "" : date.toLocaleDateString(resolveLocale(language));
};

// Formats a Firestore Timestamp (or anything Date-parseable), e.g. createdAt.
export const formatTimestampDate = (ts, language) => {
  if (!ts) return "";
  const date = ts.toDate?.() || new Date(ts);
  return isNaN(date.getTime()) ? "" : date.toLocaleDateString(resolveLocale(language));
};

// Compact, chat-list-style timestamp: just a time ("14:32") for messages
// sent today, otherwise a short date — never a full verbose string, so it
// stays readable in a narrow buddy-list row.
export const formatChatTimestamp = (ts, language) => {
  if (!ts) return "";
  const date = ts.toDate?.() || new Date(ts);
  if (isNaN(date.getTime())) return "";
  const locale = resolveLocale(language);
  const now = new Date();
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  return isToday
    ? date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })
    : date.toLocaleDateString(locale, { day: "2-digit", month: "2-digit" });
};
